import Swal from 'sweetalert2';
import './alert.scss';
let d = document;

/**
 * 
 * @param {string} type 
 * @param {string} icon 
 * @param {string} message
 * @param {boolean} close
 */

export function notify(type,{icon,message,close = false}){
    const ALERT = d.querySelector('#alert');
    ALERT.innerHTML = template(type,icon,message);
    
    const CLOSE = d.querySelector('#alert .alert_close');
    CLOSE.onclick = ()=>{
        ALERT.innerHTML = '';
    }

    if(close){
        setTimeout(()=>{
            ALERT.innerHTML = '';
        },5000);
    }
}

function template(type,icon,message){
    return `
    <div class="alert_box shadow animate__animated animate__fadeInDown">
        <div class="alert_line bga-${type}"></div>
        <div class="alert_icon">
            <i class="fas ${icon} texta-${type}"></i>
        </div>
        <div class="alert_message">
            <p id="message">${message}</p>
        </div>
        <div class="alert_close_box">
            <div class="alert_close">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15">
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"/>
                </svg>
            </div>
        </div>
    </div>
    `;
}

export function swalAlert(mensaje, cancelButton, time) {
    var progressBar = time ? true : false
    var timerText = time ? `Tiempo restante: ${Math.ceil(time / 1000)} segundos` : ''
    return Swal.fire({
        title: mensaje,
        showCancelButton: cancelButton,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
        confirmButtonColor: '#002250',
        html: time ? "Quedan <b></b>" : '',
        timer: time,
        timerProgressBar: progressBar,
        didOpen: () => {
            if (time) {
                const timer = Swal.getPopup().querySelector("b");
                let timerInterval = setInterval(() => {
                    if (Swal.getTimerLeft() < 60000) {
                        timer.textContent = `${(Swal.getTimerLeft() / 1000).toFixed(0)} segundos`;
                    }else{
                        timer.textContent = `${(Swal.getTimerLeft() / 60000).toFixed(0)} minutos`;
                    }
                }, 100);
            }
        }
    })
}